import "./Link.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _component = require("../_utils/component");

var _constant = require("../_utils/constant");

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('link'),
  mixins: [_component.componentMixin],
  props: {
    url: {
      type: [String, Object],
      required: true
    }
  },
  computed: {
    isVueRouter() {
      if (/^http/.test(this.url) || _constant.REQUEST_URL !== location.origin) return false;
      return true;
    }

  },
  methods: {
    generateHref(to) {
      var router = this.$router;
      var current = this.$route;
      var ref = router.resolve(to, current, false);
      return _constant.REQUEST_URL + ref.href;
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.isVueRouter ? _c("router-link", {
    class: _vm.bem(),
    attrs: {
      to: _vm.url
    },
    nativeOn: {
      click: function click($event) {
        return _vm.$emit("click");
      }
    }
  }, [_vm._t("default")], 2) : _c("a", {
    class: _vm.bem(),
    attrs: {
      href: _vm.generateHref(_vm.url)
    },
    on: {
      click: function click($event) {
        return _vm.$emit("click");
      }
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;